import Lottie from "lottie-react";
import React from "react";
import Errorer from "../utils/6231-404-error.json";

export const PageNotFound = () => {
  return (
    <div className="grid place-items-center">
      <div className="w-[700px] h-[300px]">
        <Lottie animationData={Errorer} loop={true} />
      </div>
    </div>
  );
};
